import { useQuery } from '@tanstack/react-query'
import ms from 'ms'

import httpClient from '@utils/HttpClient.ts'

import type { operations } from '@/schema'

export const VERSION = __APP_VERSION__

export type VersionResponse = operations['version']['responses']['200']['content']['application/json']

export function useBackendVersion() {
  return useQuery({
    queryKey: ['system-version'],
    queryFn: async () => {
      return httpClient.get<VersionResponse>('/api/version')
    },
    refetchInterval: ms('5min'),
  })
}